<script context="module">
    export const getEarnedPeriodChangeText = (data, interval) => {
        const { totalEarnedPeriodChange } = data;

        const periodChange = Math.abs(totalEarnedPeriodChange).toFixed(0);

        let prevPeriodTitle = "";

        switch (interval) {
            case 1:
                prevPeriodTitle = "last fortnight";
                break;
            case 2:
                prevPeriodTitle = "2 fortnights ago";
                break;
            case 3:
                prevPeriodTitle = "30 days ago";
                break;
            case 4:
                prevPeriodTitle = "365 days ago";
                break;
            case 5:
                prevPeriodTitle = "last month";
                break;
            case 6:
                prevPeriodTitle = "last financial year";
                break;
            case 7:
            case 8:
                return "";
        }

        if (periodChange == 0)
            return `You are invoicing the same as ${prevPeriodTitle}`;

        return `You are invoicing ${periodChange}% ${totalEarnedPeriodChange < 0 ? "less" : "more"} than ${prevPeriodTitle}`;
    };

    export const getCollectedPeriodChangeText = (data, interval) => {
        const { totalCollectedPeriodChange } = data;

        const periodChange = Math.abs(totalCollectedPeriodChange).toFixed(0);

        let prevPeriodTitle = "";

        switch (interval) {
            case 1:
                prevPeriodTitle = "last fortnight";
                break;
            case 2:
                prevPeriodTitle = "2 fortnights ago";
                break;
            case 3:
                prevPeriodTitle = "30 days ago";
                break;
            case 4:
                prevPeriodTitle = "365 days ago";
                break;
            case 5:
                prevPeriodTitle = "last month";
                break;
            case 6:
                prevPeriodTitle = "last financial year";
                break;
            case 7:
            case 8:
                return "";
        }

        if (periodChange == 0)
            return `You are collecting the same as ${prevPeriodTitle}`;

        return `You are collecting ${periodChange}% ${totalCollectedPeriodChange < 0 ? "less" : "more"} than ${prevPeriodTitle}`;
    };
</script>
